import Component from '@cell/cell-core/component/component';
import './slider.scss';

class Slider extends Component {
  constructor() {
    super();

    this.elements = {
      scrollContainer: this.querySelector('.Slider__ScrollContainer'),
      slides: this.querySelectorAll('.Slider__ScrollContainer > *'),
      navigationButtons: this.querySelectorAll('.Slider__NavigationButton'),
      bullets: this.querySelectorAll('.Slider__Bullet'),
    };

    this.currentSlideIndex = 0;

    // This is the left position of the scroll container. The distance to the left of the viewport.
    this.scrollContainerLeft = this.elements.scrollContainer.getBoundingClientRect().left;
  }

  componentDidMount() {
    this.elements.scrollContainer.on('scroll', this.handleScroll.bind(this));

    this.elements.navigationButtons.forEach((navigationButton, index) => {
      navigationButton.addEventListener('click', () => {
        this.scrollToSlide(index);
      });
    });
  }

  handleScroll() {
    this.elements.slides.forEach((slide, index) => {
      const slideLeft = slide.getBoundingClientRect().left;

      const threshold = 5;

      // If the left position of the slide is the same as the left side of the container this means
      // that the slide is fully visible and in "active" mode. Update the current slide index.
      if (
        slideLeft >= this.scrollContainerLeft - threshold &&
        slideLeft <= this.scrollContainerLeft + threshold
      ) {
        this.currentSlideIndex = index;

        this.setActiveBullet();
      }
    });
  }

  scrollToSlide(index) {
    if (index === this.currentSlideIndex) return;

    const assosiatedSlideElement = this.elements.slides[this.currentSlideIndex];

    let left = assosiatedSlideElement.getBoundingClientRect().width * index;

    this.elements.scrollContainer.scroll({ left, behaviour: 'smooth' });
  }

  setActiveBullet() {
    this.elements.bullets.forEach((bullet, bulletIndex) => {
      const isActive = bulletIndex === this.currentSlideIndex;

      bullet.classList.toggle('Slider__Bullet--Active', isActive);
    });
  }
}

customElements.define('c-slider', Slider);
